import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    Row,
    Col,
    Button,
    FormGroup,
    ControlLabel,
    FormControl,
    HelpBlock,
    Radio
} from 'react-bootstrap';
import { copy } from '../../constants';

export class InviteFailureModal extends Component {
    constructor(props) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        if (this.props.onSave) {
            this.props.onSave(this.props.user, this.props.newBrokerage);
        }
    }

    handleCancel() {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    }

    render() {
        const { user, existingBrokerage, newBrokerage } = this.props;

        let prompt = [];
        let buttonLabel = 'Change Brokerage';
        let warning = '';
        const activeMove = user && user.status && user.status !== 'pending' ? true : false;
        const username = user && [
            String(user.firstName).trim(),
            String(user.lastName).trim()
        ].filter(Boolean).join(' ') || 'User'

        if (activeMove && existingBrokerage && newBrokerage) {
            prompt = [
                `${username}'s account (${
                user.email
                }) is assigned to ${copy.clean(
                    existingBrokerage.name
                )}. Would you like to move it to ${copy.clean(newBrokerage.name)}?`
            ];
            warning = (
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12}>
                        <div className="box-warning">
                            {copy.lang('brokersInviteChangeWarning', {
                                existingBrokerage: this.props.existingBrokerage
                                    ? copy.clean(this.props.existingBrokerage.name)
                                    : ''
                            })}
                        </div>
                    </Col>
                </Row>
            );
        }

        if (!activeMove && existingBrokerage && newBrokerage) {
            prompt = [
                `${user.email} has already been invited to ${copy.clean(existingBrokerage.name)}.`
            ];
            prompt.push(
                `However, you can change their invitation so that they'll be added to  ${copy.clean(
                    newBrokerage.name
                )}.`
            );
        }

        return (
            <div>
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12}>
                        {prompt.map((part, idx) => {
                            return <p key={idx}>{part}</p>;
                        })}
                    </Col>
                </Row>
                {warning}
                <br />
                <Button className="saveEditChanges" onClick={this.handleSubmit}>
                    {buttonLabel}
                </Button>
                <Button className="cancelEdit secondary" onClick={this.handleCancel}>
                    Cancel
                </Button>
            </div>
        );
    }
}